/* eslint-disable react/prop-types,no-console */
import React from "react"

//
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo })
  }

  render() {
    const { hasError, error, errorInfo } = this.state
    const { FallbackComponent, children, ...others } = this.props

    if (hasError && !FallbackComponent) {
      // log error... and render children
      console.warn("[ErrorBoundary] Missing FallbackComponent.")
      return children
    }

    if (hasError) {
      return (
        <FallbackComponent error={error} erroInfo={errorInfo} {...others} />
      )
    }

    return children
  }
}
